import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sharing-your-plugin"
    }}>{`Sharing Your Plugin`}</h1>
    <p>{`Unless you've written a plugin solely for yourself, you're probably going to want to share it with others. This section explains how to take your plugin into the wider world, and let other users know about it.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/guides/distribution/packaging-your-plugin/"
        }}>{`Packaging Your Plugin`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/guides/distribution/distribution-options/"
        }}>{`Options for Distribution`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/guides/distribution/submission-checklist/"
        }}>{`Submission and Review`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/guides/distribution/marketing/"
        }}>{`Marketing Your Plugin`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      